<template>
  <div class="app-change-phone">
    <b-form-group class="phone-group" label="alternativePhone" label-class="visually-hidden">
      <b-row class="phone">
        <b-col md="" cols="12" class="label">
          <label for="alternativePhone">
            <slot name="labelPhone">Telefonnummer:</slot>
          </label>
        </b-col>
        <b-col md="" cols="12">
          <b-form-input
            id="alternativePhone"
            name="alternativePhone"
            type="text"
            @input="$v.currentCustomer.alternativePhone.$touch"
            :state="isValid('currentCustomer.alternativePhone')"
            v-model.trim="currentCustomer_.alternativePhone"
          ></b-form-input>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
import { BFormInput, BRow, BCol, BFormGroup } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import isValid from '../../../../mixins/isValid'
import syncProperty from '@/mixins/syncProperty'
import { helpers } from 'vuelidate/lib/validators'
const isPhoneNumber = helpers.regex('phoneNumber', /^[+]?[0-9]*$/)
export default {
  name: 'PhoneDataForm',
  data () {
    return {
    }
  },
  components: {
    BFormInput, BRow, BCol, BFormGroup
  },
  methods: {
  },
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  mixins: [
    validationMixin,
    isValid,
    syncProperty('currentCustomer', 'currentCustomer_')
  ],
  validations () {
    return {
      currentCustomer: {
        alternativePhone: {
          isPhoneNumber
        }
      }
    }
  }
}
</script>
